import { render, staticRenderFns } from "./CameraComponent.vue?vue&type=template&id=e171525a&scoped=true"
import script from "./CameraComponent.vue?vue&type=script&lang=js"
export * from "./CameraComponent.vue?vue&type=script&lang=js"
import style0 from "./CameraComponent.vue?vue&type=style&index=0&id=e171525a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e171525a",
  null
  
)

export default component.exports